<template>
<div class="page-wrapper">
  <div class="page" id="material-dark">
    <div class="page-inner">
      <component is="material-dark"></component>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import '../resumes/resumes';
export default Vue.component('resume', {
  name: 'app'
});
</script>

<style scoped>
.page-inner{
  height: 100%;
  margin: 0 auto;
}
.page-wrapper {
  overflow-x: auto;
  background: #CCCCCC;
  margin: 0;
  padding: 0;
  width: 100%;
  -webkit-print-color-adjust: exact;
  box-sizing: border-box;
}

.resume {
  height: 100%;
  width: 100%;
}

.page {
  position: relative;
  width: 21cm;
  height: 29.68cm;
  display: block;
  page-break-after: auto;
  overflow: hidden;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/resume.vue